import { useEffect, useState } from "react";
import { actionEmitter, EmitEvent } from "../../../config/ActionEmitter";
import styles from "./designer.module.scss";

interface ILayoutPreview {
  previewUrl: string;
  mode: "desktop" | "phone";
  onModeChange: (mode: "desktop" | "phone") => void;
  onClose: () => void;
}

const frameWidth = {
  desktop: 1280,
  phone: 390
};

const LayoutPreview = ({ previewUrl, mode, onModeChange, onClose }: ILayoutPreview): JSX.Element => {
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    const refresh = (): void => {
      setRevision((value) => value + 1);
    };

    actionEmitter.on(EmitEvent.LayoutChanged, refresh);

    return () => {
      actionEmitter.off(EmitEvent.LayoutChanged, refresh);
    };
  }, []);

  const src = previewUrl
    ? `${previewUrl}${previewUrl.includes("?") ? "&" : "?"}reload=${revision}`
    : "";

  return (
    <section className={styles.layoutPreview}>
      <div className={styles.layoutPreviewHeader}>
        <span>Page preview</span>
        <div className={styles.layoutPreviewModes}>
          <button
            type="button"
            className={mode === "desktop" ? styles.layoutPreviewModeActive : styles.layoutPreviewMode}
            onClick={() => onModeChange("desktop")}>
            Desktop
          </button>
          <button
            type="button"
            className={mode === "phone" ? styles.layoutPreviewModeActive : styles.layoutPreviewMode}
            onClick={() => onModeChange("phone")}>
            Phone
          </button>
          <button type="button" className={styles.layoutPreviewMode} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
      {src ? (
        <div className={styles.layoutPreviewScroll}>
          <iframe
            key={`${mode}-${revision}`}
            title="Page layout preview"
            className={styles.layoutPreviewFrame}
            style={{ width: frameWidth[mode] }}
            src={src}
          />
        </div>
      ) : (
        <p className={styles.layoutPreviewEmpty}>Preview is not available for this version.</p>
      )}
    </section>
  );
};

export default LayoutPreview;
